const config = {};

config.REACT_APP_BASE_URL = window._env_?.REACT_APP_BASE_URL === "#BASE_URL#" ? "https://api-dev.tpaoficial.com/api/" : window._env_?.REACT_APP_BASE_URL;
 //config.REACT_APP_BASE_URL = window._env_?.REACT_APP_BASE_URL === "#BASE_URL#" ? "https://localhost:7250/api/" : window._env_?.REACT_APP_BASE_URL;

// console.log(window._env_);
// console.log(config);

export default config;